import React from 'react'
import UiInputText from "../components/Form/UiInputText";
import UiInputDate from "../components/Form/UiInputDate";
import Form from "../components/Form/Form";
import {useForm, FormProvider} from "react-hook-form";
import FormContainer from '../components/Form/FormContainer';
import Button from 'react-bootstrap/Button';
import UiInputSuggest from "../components/Form/UiInputSuggest";
import UiInputList from "../components/Form/UiInputList";
import UiInputMoney from "../components/Form/UiInputMoney";

export default function ContaReceberForm(props: any){
    const today = new Date().toISOString().split('T')[0];
    const methods = useForm({
        defaultValues: props.data || { status: 'aberta', dataEmissao: today }
    });
    const { handleSubmit } = methods;

    const statusList = [
        { id: 'aberta', title: 'Aberta' },
        { id: 'parcial', title: 'Parcial' },
        { id: 'quitada', title: 'Quitada' },
        { id: 'cancelada', title: 'Cancelada' },
    ];

    return (
        <FormContainer size="lg" show={true} onHide={props.triggerClose}>
            <FormProvider {...methods}>
                <Form onSubmit={handleSubmit(props.triggerSubmit)} methods={methods}>
                    <FormContainer.Header onClose={props.triggerClose}>
                        <h5>{props.data?.id ? 'Editar Conta a Receber' : 'Nova Conta a Receber'}</h5>
                    </FormContainer.Header>
                    <FormContainer.Body>
                        <div className="row">
                            <div className="col-12">
                                <fieldset>
                                    <legend>Vinculação</legend>
                                    <div className="row">
                                        <UiInputSuggest size={12} router="contrato" idField="id" titleField="cli_nome" name="contrato" label="Contrato" required />
                                    </div>
                                </fieldset>
                            </div>
                            <div className="col-12">
                                <fieldset>
                                    <legend>Dados da Conta a Receber</legend>
                                    <div className="row">
                                        <UiInputText size={12} name="descricao" label="Descrição" required />
                                        <UiInputMoney size={3} name="valorTotal" label="Valor Total" required />
                                        <UiInputDate size={3} name="dataEmissao" label="Data Emissão" dateFormat="dd/mm/yy" />
                                        <UiInputDate size={3} name="dataVencimento" label="Data Vencimento" dateFormat="dd/mm/yy" />
                                        <UiInputList size={3} name="status" list={statusList} idField="id" titleField="title" label="Status" />
                                        <UiInputText size={12} name="observacoes" label="Observações" />
                                    </div>
                                </fieldset>
                            </div>
                        </div>
                    </FormContainer.Body>
                    <FormContainer.Footer>
                        <Button variant="secondary" onClick={props.triggerClose}>Fechar</Button>
                        <Button variant="primary" type="submit">Salvar</Button>
                    </FormContainer.Footer>
                </Form>
            </FormProvider>
        </FormContainer>
    )
}
